import apiSlice from "./ApiSlice";

export const TestSeriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL TestSeries WITH PAGINATION
    getAllTestSeriesWithPagination: builder.query({
      providesTags: ["test-series"],
      query: (body) => {
        return {
          url: "/test",
          method: "POST",
          body,
        };
      },
    }),

    // GET ALL TestSeries
    getAllTestSeries: builder.query({
      providesTags: ["test-series"],
      query: () => {
        return {
          url: "/test",
          method: "GET",
        };
      },
    }),

    // Add
    addTestSeries: builder.mutation({
      invalidatesTags: ["test-series"],
      query: (body) => {
        return {
          url: "/test/add",
          method: "POST",
          body,
        };
      },
    }),

    // Assign Test To students
    assignTest: builder.mutation({
      invalidatesTags: ["test-series"],
      query: (body) => {
        return {
          url: "/test/assign-test-to-student",
          method: "PUT",
          body,
        };
      },
    }),

    // DELETE
    deleteTestSeries: builder.mutation({
      invalidatesTags: ["test-series"],
      query: ({ id }) => {
        return {
          url: `/test/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET TestSeries BY ID
    getTestSeriesById: builder.query({
      providesTags: ["test-series"],
      query: ({ id }) => {
        return {
          url: `/test/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editTestSeries: builder.mutation({
      invalidatesTags: ["test-series"],
      query: ({ body, id }) => {
        return {
          url: `/test/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetAllTestSeriesWithPaginationQuery,
  useGetAllTestSeriesQuery,
  useAddTestSeriesMutation,
  useDeleteTestSeriesMutation,
  useEditTestSeriesMutation,
  useAssignTestMutation,
  useGetTestSeriesByIdQuery,
} = TestSeriesApi;
